import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
import * as moment from "moment";
import { BetInfo } from "src/_models/bet";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import { SapRoles } from "src/_constants/roleType";
type filters = {
  sportId?: string;
  startTime?: number;
  endTime?: number;
  providerId: string;
  operatorId: string;
  PageSize?: number;
  Page?: number;
  sportName?: string;
  betCountOrder: number;
  profitLossOrder: number;
  userId: string;
  origin: string;
};

export interface DialogData {
  betInfo: BetInfo;
}

@Component({
  selector: "app-user-pl",
  templateUrl: "./user-pl.component.html",
  styleUrls: ["./user-pl.component.scss"],
})
export class UserPLComponent implements OnInit {
  ascendingValue: any = null;
  ascendingValueBC: any = null;
  betCountOrder: number = 0;
  profitLossOrder: number = 1;

  filters: filters;
  betDisplayedColumns: string[] = [
    "Username",
    "Sports",
    "betCount",
    "profitLoss",
  ];

  today = new Date();
  formDate = new FormControl(this.today);
  toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  tableData = new MatTableDataSource<any>();
  sapRoles = SapRoles;
  sports = [];

  selectedProvider = "";
  selectedSport = new FormControl([this.sports[0]]);
  selectedUser: { userId: string; userName: string };
  selected: any = {
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate:
      Number(new Date().setHours(23, 59, 59).toString().slice(0, 10)) * 1000,
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  ProviderId = new FormControl([]);
  OperatorId = new FormControl([]);
  operatorData = [];
  showAlert: any = false;
  length: any = 0;
  page = 1;
  pageSize = 25;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  dropdownSettings: any = {};
  sportSettings: any = {};
  operatorSettings: any = {};
  origin = new FormControl([]);
  origins = ["SPORTSBOOK","PREMIUM","VIRTUAL","EXPREMIUM"];
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {
    this.changeTableColumns();
    // this.getOurProviders();
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.operatorSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.getOperatorData();
    this.getAdminProviders();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  changeTableColumns() {
    this.betDisplayedColumns =
    [this.sapRoles.SAPAdmin].includes(this.userRole.role) ?
      [
        "Username",
        "OperatorId",
        "Sports",
        "betCount",
        "profitLoss",
      ]
    : [
      "Username",
      "Sports",
      "betCount",
      "profitLoss",
    ]
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getAdminProviders() {
    if (
      this.userRole.role === this.sapRoles.SAPAdmin ||
      this.userRole.role === this.sapRoles.SAPUser ||
      this.userRole.role === this.sapRoles.RiskAdmin
    ) {
      this.providers = ["Exchange", "SportsBook"];
    }
    this.onSelectedProvider(this.providers[0]);
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.map(
            (operator) => operator.operator_id
          );
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.ProviderId.setValue([pid]);
  };

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          this.sports.unshift({ SportId: "All", SportName: "All" });
          this.selectedSport.setValue([this.sports[0]]);
          this.getTableData();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedOperatorId = (OperatorId) => {
    this.OperatorId.setValue([OperatorId]);
    this.getTableData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 35) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        this.getTableData();
      }
    }
  };

  changePagination(event: Event) {
    this.pageEvent = event;
    this.pageSize = this.pageEvent.pageSize;
    this.page = this.pageEvent.pageIndex + 1;
    this.getTableData();
  }

  onUserSelection(event: any) {
    // console.log("user", event);
    this.selectedUser = event;
  }

  onUserSelectionClear() {
    this.selectedUser = null;
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getExportExcel() {
    let filters: filters = {
      profitLossOrder: this.profitLossOrder,
      betCountOrder: this.betCountOrder,
      providerId:
        this.ProviderId.value[0].length === 0 ? "" : this.ProviderId.value[0],
      operatorId:
        this.OperatorId.value.length === 0 ? [] : this.OperatorId.value,
        userId: this.selectedUser ? this.selectedUser.userId : null,
        origin: this.origin.value.length != 0 ? this.origin.value : [],
      sportId:
        this.selectedSport.value[0].SportId === "All"
          ? ""
          : this.selectedSport.value[0].SportId,
      startTime:
        this.selected.startDate !== null
          ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      sportName: "Cricket",
    };
    this.appService.getPLExportExcel(filters).subscribe((res) => {
      const contentType = "application/vnd.ms-excel";
      let blob1 = this.b64toBlob(res.file, contentType);
      let blobUrl1 = URL.createObjectURL(blob1);
      const link = document.createElement("a");
      link.href = blobUrl1;
      link.setAttribute("download", `user_pl.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  }
  getTableData() {
    console.log("hi");
    const pagination = {
      Number: 10,
      Page: 1,
    };
    console.log("ProviderId", this.ProviderId.value);
    let filters: filters = {
      profitLossOrder: this.profitLossOrder,
      betCountOrder: this.betCountOrder,
      providerId:
        this.ProviderId.value[0].length === 0 ? "" : this.ProviderId.value[0],
      operatorId:
        this.OperatorId.value.length === 0 ? [] : this.OperatorId.value,
      userId: this.selectedUser ? this.selectedUser.userId : null,
      origin: this.origin.value.length != 0 ? this.origin.value : [],
      sportId:
        this.selectedSport.value[0].SportId === "All"
          ? ""
          : this.selectedSport.value[0].SportId,
      startTime:
        this.selected.startDate !== null
          ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      PageSize: this.pageSize,
      Page: this.page,
    };
    console.log("hi");

    this.appService.getuserPlData(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.tableData = new MatTableDataSource<any>(res.sportPnLReport);
        if (this.page == 1) {
          this.length = res.totalBets;
        } else {
          this.paginator.length = this.length;
        }
      }
    });
  }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm A");
  };

  handleSortingOnPL() {
    this.betCountOrder = 0;
    if (this.profitLossOrder === 1) {
      this.profitLossOrder = -1;
      this.getTableData();
    } else {
      this.profitLossOrder = 1;
      this.getTableData();
    }
  }

  handleSortingOnBC() {
    this.profitLossOrder = 0;
    if (this.betCountOrder === 1) {
      this.betCountOrder = -1;
      this.getTableData();
    } else {
      this.betCountOrder = 1;
      this.getTableData();
    }
  }

  onChangeSports(sport) {
    this.selectedSport.setValue([sport.name]);
    this.getTableData();
  }

  onChangeEvent() {
    this.getTableData();
  }

  onChangeUser() {
    this.getTableData();
  }

  onChangeStatus() {
    this.getTableData();
  }
}
